import { render } from "./SvgPolygon.vue?vue&type=template&id=e76964b8&ts=true"
import script from "./SvgPolygon.vue?vue&type=script&lang=ts"
export * from "./SvgPolygon.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__